import type { HydratedSearchUrl } from './search-url';
import {
  parsePageMetadataFacets,
  readPageMetadataFiltersFromDocument,
  type PageMetadataFilters,
} from './parse-page-metadata-facets';

export type InitialFacetOptions = {
  /** When true (search page), page metadata filters are not applied. */
  showTextSearch?: boolean;
  /** Matrix `data-props` metadata filters (preferred over `<meta>` tags). */
  pageMetadataFilters?: PageMetadataFilters;
};

function hasSelectedFacets(selectedFacets: Record<string, string[]>): boolean {
  return Object.values(selectedFacets).some((values) => values.length > 0);
}

function mergePageMetadataFilters(
  fromProps?: PageMetadataFilters,
): PageMetadataFilters {
  const fromDocument = readPageMetadataFiltersFromDocument();
  return {
    'dxp-topic':
      fromProps?.['dxp-topic']?.trim() || fromDocument['dxp-topic'] || '',
    'dxp-faculty':
      fromProps?.['dxp-faculty']?.trim() || fromDocument['dxp-faculty'] || '',
  };
}

/**
 * Landing pages with a clean URL (no `f.*` params) seed facets from page metadata.
 * URL facets always win when present.
 */
export function resolveInitialSelectedFacets(
  hydrated: HydratedSearchUrl,
  options: InitialFacetOptions = {},
): Record<string, string[]> {
  if (hasSelectedFacets(hydrated.selectedFacets)) {
    return { ...hydrated.selectedFacets };
  }

  if (options.showTextSearch !== false) {
    return {};
  }

  const filters = mergePageMetadataFilters(options.pageMetadataFilters);
  return parsePageMetadataFacets(filters);
}
